module.exports = __webpack_public_path__ + "static/img/ssi_logo.aa15c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssi_logo.png
// module id = MyC3
// module chunks = 2